(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    let isInitialized = false;
    
    function initMegaCardGrouping() {
      // Group sections with consecutive numeric IDs into 2 columns
      // Also include rich-text-grouped sections that match IDs
      const megaCardSections = document.querySelectorAll('[data-mega-card][data-mega-card-id]');
      
      // If no sections found, exit early (but don't mark as initialized so it can retry)
      if (megaCardSections.length === 0) {
        return;
      }
      
      // Check if already grouped to prevent double execution
      const alreadyGrouped = Array.from(megaCardSections).some(section => 
        section.parentElement && section.parentElement.classList.contains('mega-product-cards-group')
      );
      
      if (alreadyGrouped) {
        // Mark sections as grouped and make them visible
        megaCardSections.forEach(section => {
          section.classList.add('mega-product-cards-grouped');
        });
        isInitialized = true;
        return;
      }
      
      const richTextSections = document.querySelectorAll('[data-rich-text-grouped][data-rich-text-grouped-id]');
      const sectionsWithIds = [];
      const richTextMap = new Map();
    
    // Map rich-text sections by their ID
    richTextSections.forEach(section => {
      const sectionId = section.getAttribute('data-rich-text-grouped-id');
      if (sectionId && sectionId !== '') {
        richTextMap.set(sectionId, section);
      }
    });
    
    // Extract mega-card sections with numeric IDs
    megaCardSections.forEach(section => {
      const sectionId = section.getAttribute('data-mega-card-id');
      if (sectionId && sectionId !== '') {
        // Extract numeric part from ID (e.g., "product-1" -> 1, "5" -> 5)
        const numericMatch = sectionId.match(/(\d+)/);
        if (numericMatch) {
          const numericId = parseInt(numericMatch[1], 10);
          sectionsWithIds.push({
            element: section,
            id: sectionId,
            numericId: numericId,
            type: 'mega-card'
          });
        }
      }
    });
    
    // Sort by numeric ID
    sectionsWithIds.sort((a, b) => a.numericId - b.numericId);
    
    // Group consecutive IDs
    const groups = [];
    let currentGroup = [];
    
    sectionsWithIds.forEach((item, index) => {
      if (currentGroup.length === 0) {
        currentGroup.push(item);
      } else {
        const prevNumericId = currentGroup[currentGroup.length - 1].numericId;
        // Check if this ID is consecutive (diff of 1)
        if (item.numericId === prevNumericId + 1) {
          currentGroup.push(item);
        } else {
          // Start a new group
          if (currentGroup.length >= 2) {
            groups.push(currentGroup);
          }
          currentGroup = [item];
        }
      }
    });
    
    // Add the last group if it has 2+ items
    if (currentGroup.length >= 2) {
      groups.push(currentGroup);
    }
    
    // Wrap groups in containers
    groups.forEach(group => {
      // Check if already wrapped
      if (group[0].element.parentElement.classList.contains('mega-product-cards-group')) {
        return;
      }
      
      // Find matching rich-text section for this group
      const groupIds = group.map(g => g.id);
      let richTextSection = null;
      for (const id of groupIds) {
        if (richTextMap.has(id)) {
          richTextSection = richTextMap.get(id);
          break;
        }
      }
      
      // Get settings from first section (lower ID)
      const firstSection = group[0].element;
      const paddingTop = parseInt(firstSection.getAttribute('data-inner-padding-top') || '0', 10);
      const paddingBottom = parseInt(firstSection.getAttribute('data-inner-padding-bottom') || '0', 10);
      const paddingLeft = parseInt(firstSection.getAttribute('data-inner-padding-left') || '0', 10);
      const paddingRight = parseInt(firstSection.getAttribute('data-inner-padding-right') || '0', 10);
      const cornerRadius = parseInt(firstSection.getAttribute('data-inner-corner-radius') || '0', 10);
      
      // Get outer properties from first section
      const colorScheme = firstSection.getAttribute('data-color-scheme') || '';
      const width = firstSection.getAttribute('data-width') || 'page';
      const outerPaddingTop = parseInt(firstSection.getAttribute('data-padding-top') || '60', 10);
      const outerPaddingBottom = parseInt(firstSection.getAttribute('data-padding-bottom') || '60', 10);
      const sideMargin = parseInt(firstSection.getAttribute('data-side-margin') || '0', 10);
      
      // Get computed styles from first section for background
      const firstSectionStyles = window.getComputedStyle(firstSection);
      const backgroundColor = firstSectionStyles.backgroundColor;
      const backgroundImage = firstSectionStyles.backgroundImage;
      
      // Create wrapper and copy all relevant classes from first section
      const wrapper = document.createElement('div');
      wrapper.className = 'mega-product-cards-group';
      
      // Copy classes from first section (color scheme, width, etc.)
      Array.from(firstSection.classList).forEach(className => {
        // Copy color scheme and gradient classes
        if (className.startsWith('color-') || className === 'gradient') {
          wrapper.classList.add(className);
        }
        // Copy width class
        if (className === 'page-width') {
          wrapper.classList.add(className);
        }
      });
      
      // Also add classes from data attributes if not already present
      if (width === 'page' && !wrapper.classList.contains('page-width')) {
        wrapper.classList.add('page-width');
      }
      if (colorScheme && !wrapper.classList.contains('color-' + colorScheme)) {
        wrapper.classList.add('color-' + colorScheme, 'gradient');
      }
      
      wrapper.setAttribute('data-group-ids', group.map(g => g.numericId).join(','));
      
      // Apply side margins from side_margin setting (same as personas section)
      if (sideMargin > 0) {
        wrapper.setAttribute('data-side-margin', sideMargin);
        wrapper.style.setProperty('--side-margin-value', sideMargin + 'px');
      }
      
      // Apply outer padding (top and bottom from section settings)
      // Side padding (left/right) is handled by CSS (36px mobile, 120px desktop)
      
      // Apply inner padding (all sides from inner padding settings)
      if (paddingTop > 0 || paddingBottom > 0 || paddingLeft > 0 || paddingRight > 0) {
        // Combine outer padding top/bottom with inner padding
        // Note: left/right padding is handled by CSS, so we only set top/bottom here
        wrapper.style.paddingTop = (outerPaddingTop + paddingTop) + 'px';
        wrapper.style.paddingBottom = (outerPaddingBottom + paddingBottom) + 'px';
      } else {
        // Just use outer padding if no inner padding
        wrapper.style.paddingTop = outerPaddingTop + 'px';
        wrapper.style.paddingBottom = outerPaddingBottom + 'px';
      }
      
      if (cornerRadius > 0) {
        wrapper.style.borderRadius = cornerRadius + 'px';
      }
      
      // Apply background from first section (if not transparent)
      if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
        wrapper.style.backgroundColor = backgroundColor;
      }
      if (backgroundImage && backgroundImage !== 'none') {
        wrapper.style.backgroundImage = backgroundImage;
        wrapper.style.backgroundSize = firstSectionStyles.backgroundSize;
        wrapper.style.backgroundRepeat = firstSectionStyles.backgroundRepeat;
        wrapper.style.backgroundPosition = firstSectionStyles.backgroundPosition;
      }
      
      // Insert wrapper before first section (or before rich-text if it exists)
      const insertBefore = richTextSection || firstSection;
      insertBefore.parentNode.insertBefore(wrapper, insertBefore);
      
      // Add rich-text section first if it exists
      if (richTextSection) {
        // Remove all background-related classes from rich-text section
        const classesToRemove = [];
        Array.from(richTextSection.classList).forEach(className => {
          if (className.startsWith('color-scheme-') || className === 'gradient' || className.startsWith('color-')) {
            classesToRemove.push(className);
          }
        });
        classesToRemove.forEach(className => richTextSection.classList.remove(className));
        
        // Remove background styles from rich-text section
        richTextSection.style.setProperty('background', 'none', 'important');
        richTextSection.style.setProperty('background-color', 'transparent', 'important');
        richTextSection.style.setProperty('background-image', 'none', 'important');
        
        // Also remove backgrounds from inner content container
        const contentContainer = richTextSection.querySelector('.rich-text.content-container');
        if (contentContainer) {
          const containerClassesToRemove = [];
          Array.from(contentContainer.classList).forEach(className => {
            if (className.startsWith('color-scheme-') || className === 'gradient' || className.startsWith('color-')) {
              containerClassesToRemove.push(className);
            }
          });
          containerClassesToRemove.forEach(className => contentContainer.classList.remove(className));
          
          contentContainer.style.setProperty('background', 'none', 'important');
          contentContainer.style.setProperty('background-color', 'transparent', 'important');
          contentContainer.style.setProperty('background-image', 'none', 'important');
          
          // Remove padding-top and padding-bottom from content container when grouped
          contentContainer.style.setProperty('padding-top', '0', 'important');
          contentContainer.style.setProperty('padding-bottom', '0', 'important');
        }
        
        // Also remove padding from any padding class elements
        const paddingElements = richTextSection.querySelectorAll('[class*="-padding"]');
        paddingElements.forEach(element => {
          element.style.setProperty('padding-top', '0', 'important');
          element.style.setProperty('padding-bottom', '0', 'important');
        });
        
        wrapper.appendChild(richTextSection);
      }
      
      // Move all mega-card sections into wrapper and remove backgrounds
      const megaCardItems = group.filter(item => item.type === 'mega-card');
      megaCardItems.forEach((item, index) => {
        const section = item.element;
        
        // Mark first and last mega-card sections for padding
        if (index === 0) {
          section.setAttribute('data-group-position', 'first');
        }
        if (index === megaCardItems.length - 1) {
          section.setAttribute('data-group-position', 'last');
        }
        
        // Remove all background-related classes from section
        const classesToRemove = [];
        Array.from(section.classList).forEach(className => {
          if (className.startsWith('color-scheme-') || className === 'gradient' || className.startsWith('color-')) {
            classesToRemove.push(className);
          }
        });
        classesToRemove.forEach(className => section.classList.remove(className));
        
        // Remove background styles from section with !important
        section.style.setProperty('background', 'none', 'important');
        section.style.setProperty('background-color', 'transparent', 'important');
        section.style.setProperty('background-image', 'none', 'important');
        
        // Remove padding-top and padding-bottom from grouped sections (only group div should have these)
        section.style.setProperty('padding-top', '0', 'important');
        // Exception: Don't override padding-bottom for specific template on mobile (handled by CSS)
        const isSpecificTemplate = section.classList.contains('mega-product-cards--template--26299991195972__mega_product_cards_3dVRYG');
        const isFirstInGroup = section.getAttribute('data-group-position') === 'first' || section.matches(':first-of-type');
        if (!(isSpecificTemplate && isFirstInGroup)) {
          section.style.setProperty('padding-bottom', '0', 'important');
        }
        
        // Set padding-left: 0 for div with id="2" (second card in group)
        const sectionId = section.getAttribute('id');
        const megaCardId = section.getAttribute('data-mega-card-id');
        if (sectionId === '2' || megaCardId === '2' || sectionId === 'mega-product-cards-2') {
          section.style.setProperty('padding-left', '0', 'important');
        }
        
        // Note: inner container settings (padding, radius, background) should be preserved
        // These are handled by CSS rules using section ID selectors
        
        wrapper.appendChild(section);
      });
    });
    
    // Mark as initialized after successful grouping
    if (groups.length > 0) {
      isInitialized = true;
    }
    
    // Always make sections visible after processing (even if no groups were created)
    // This prevents sections from staying hidden if grouping fails
    megaCardSections.forEach(section => {
      section.classList.add('mega-product-cards-grouped');
    });
    }
    
    // Run when DOM is ready with delays to ensure all sections are rendered
    function runGrouping(retryCount = 0) {
      const maxRetries = 10;
      const delay = retryCount === 0 ? 100 : Math.min(200 * retryCount, 1000);
      
      setTimeout(function() {
        const sections = document.querySelectorAll('[data-mega-card][data-mega-card-id]');
        
        // Debug logging (can be removed in production)
        if (retryCount === 0 || sections.length > 0) {
          console.log('[Mega Cards Grouping] Attempt', retryCount + 1, '- Found', sections.length, 'sections');
        }
        
        if (sections.length === 0 && retryCount < maxRetries) {
          // Sections not found yet, retry with increasing delay
          runGrouping(retryCount + 1);
        } else {
          // Sections found or max retries reached, run grouping
          if (sections.length > 0) {
            initMegaCardGrouping();
          } else {
            console.warn('[Mega Cards Grouping] No sections found after', maxRetries, 'attempts');
            // Even if no sections found, make any existing sections visible as fallback
            const existingSections = document.querySelectorAll('[data-mega-card][data-mega-card-id]');
            existingSections.forEach(section => {
              section.classList.add('mega-product-cards-grouped');
            });
          }
        }
      }, delay);
    }
    
    // Multiple initialization strategies for better compatibility
    function initializeGrouping() {
      if (isInitialized) {
        return;
      }
      runGrouping();
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initializeGrouping();
      });
    } else {
      // DOM already loaded, run with delay
      initializeGrouping();
    }
    
    // Fallback: Also run on window load (ensures all resources are loaded)
    window.addEventListener('load', function() {
      if (!isInitialized) {
        console.log('[Mega Cards Grouping] Window load fallback triggered');
        isInitialized = false;
        initializeGrouping();
      }
      
      // Final fallback: ensure all sections are visible even if grouping didn't work
      setTimeout(function() {
        const allSections = document.querySelectorAll('[data-mega-card][data-mega-card-id]');
        allSections.forEach(section => {
          if (!section.classList.contains('mega-product-cards-grouped')) {
            console.log('[Mega Cards Grouping] Final fallback - making sections visible');
            section.classList.add('mega-product-cards-grouped');
          }
        });
      }, 2000);
    });
    
    // Re-run when Shopify loads sections (for theme editor) - reset flag
    document.addEventListener('shopify:section:load', function() {
      console.log('[Mega Cards Grouping] Section load event triggered');
      isInitialized = false;
      initializeGrouping();
    });
    
    // Additional fallback: MutationObserver to watch for new sections
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        const hasNewSections = Array.from(mutations).some(function(mutation) {
          return Array.from(mutation.addedNodes).some(function(node) {
            return node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-mega-card');
          });
        });
        
        if (hasNewSections && !isInitialized) {
          console.log('[Mega Cards Grouping] MutationObserver detected new sections');
          setTimeout(function() {
            isInitialized = false;
            initializeGrouping();
          }, 300);
        }
      });
      
      // Start observing when DOM is ready
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
